<template>
  <div class="email">
    <div v-if="!hasSmsGateIntegrations" class="email_alert">
      <Icon name="warning" class="alert_icon" />
      <span>Для отправки email требуется подключенная интеграция SMSGate</span>
    </div>

    <div v-else>
      <div class="subtitle">Интеграция SMSGate</div>
      <v-select
        v-model="data_local.smsgate_integration_id"
        :items="smsGateIntegrations || []"
        item-text="name"
        item-value="guid"
        outlined
        dense
        @change="input"
      />
      <div class="subtitle">Куда отправлять письмо</div>
      <v-select
        v-model="data_local.recipient_type"
        :items="[
          { text: 'Клиенту', value: 'client' },
          { text: 'На другую почту', value: 'custom' },
        ]"
        outlined
        dense
        @change="input"
      />

      <div v-if="data_local.recipient_type === 'custom'">
        <div class="subtitle">Email получателя</div>
        <v-text-field
          v-model="data_local.recipient_email"
          type="email"
          placeholder="client@example.com"
          outlined
          dense
          @input="input"
        />
      </div>

      <div class="subtitle">Email отправителя</div>
      <v-text-field
        v-model="data_local.sender_name"
        placeholder="mailer@domain.ru"
        outlined
        dense
        @input="input"
      />

      <div class="subtitle">Тема письма</div>
      <v-text-field
        v-model="data_local.email_subject"
        placeholder="Тема письма"
        outlined
        dense
        @input="input"
      />

      <h3>Текст письма</h3>
      <v-textarea
        class="my_textarea"
        auto-grow
        v-model="data_local.sms_text"
        placeholder="Введите текст или HTML письма"
        outlined
        @input="input"
      />
      <div class="paste" @click="pasteVariable('phone')">Номер клиента</div>
      <div class="paste" @click="pasteVariable('phoneA')">Номер звонка</div>
      <div class="paste" @click="pasteVariable('target')">Цели</div>
      <div class="paste" @click="pasteVariable('answer')">Ответ клиента</div>
      <div class="paste" @click="pasteVariable('record')">Запись звонка</div>
      <div class="paste" @click="pasteVariable('callname')">
        Название обзвона
      </div>
      <div class="paste" @click="pasteVariable('script')">
        Название сценария
      </div>
      <div class="paste" @click="pasteVariable('base')">Название базы</div>
      <div class="row">
        <div class="num_symbols">
          Символов: {{ (data_local.sms_text || '').length }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../../SetIcon.vue';

export default {
  props: ['data', 'edit_callback', 'smsGateIntegrations'],

  components: {
    Icon,
  },

  data() {
    return {
      data_local: {
        message_channel: 'email',
        sms_service: 'SMSGate',
        recipient_type: 'client',
        recipient_email: '',
        smsgate_integration_id: '',
        sender_name: '',
        email_subject: '',
        sms_text: '',
        type: 0,
        phone: '',
      },
    };
  },

  computed: {
    hasSmsGateIntegrations() {
      return this.smsGateIntegrations && this.smsGateIntegrations.length > 0;
    },
  },

  watch: {
    data: {
      immediate: true,
      handler(val) {
        this.data_local = {
          ...this.data_local,
          ...(val || {}),
          message_channel: 'email',
          sms_service: 'SMSGate',
        };

        this.setDefaultIntegration();
      },
    },

    smsGateIntegrations() {
      this.setDefaultIntegration();
    },
  },

  mounted() {
    this.setDefaultIntegration();
  },

  methods: {
    setDefaultIntegration() {
      if (
        !this.data_local.smsgate_integration_id &&
        this.smsGateIntegrations &&
        this.smsGateIntegrations.length
      ) {
        this.data_local.smsgate_integration_id =
          this.smsGateIntegrations[0].guid;
        this.input();
      }
    },

    pasteVariable(name) {
      this.data_local.sms_text =
        String(this.data_local.sms_text || '') + `{${name}}`;

      this.input();
    },

    input() {
      this.edit_callback(this.data_local);
      return true;
    },
  },
};
</script>

<style scoped>
.email {
  max-width: 600px;
  width: 600px;
  margin: 32px auto 0 auto;
}

.email_alert {
  background-color: #fffbea;
  color: #ffb74d;
  padding: 10px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  text-align: center;
}

.subtitle {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  color: #404247;
  text-align: left;
  margin: 14px 0 6px;
}

.my_textarea {
  margin-top: 8px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 12px 0 0 0 !important;
}

.num_symbols {
  color: #777;
  font-size: 13px;
}
.paste {
  padding: 9px 20px 10px;
  background: #ffffff;
  display: inline-block;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  margin: 12px 0 0 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  line-height: 110%;
  color: #2b2d33;
}
</style>